module.exports = __webpack_public_path__ + "img/01.ed0bbe7b.jpg";